// @context TGW-2195 オンライン開催は接続先が無いと参加できないため、公開前に
//   http/https のURLだけを受け付け、下書き保存は未入力のまま許可する。
export const onlineUrlError = ({ isOnline, url }) => {
  if (!isOnline) return '';

  const value = String(url || '').trim();
  if (!value) return '接続先URLを入力してください。';

  try {
    const parsed = new URL(value);
    if (
      (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
      parsed.hostname
    ) {
      return '';
    }
  } catch (_error) {
    // 下の共通メッセージで入力方法を案内する。
  }

  return 'http:// または https:// から始まるURLを入力してください。';
};

export default onlineUrlError;
